import React from "react";

import html from "../assets/html.png";
import css from "../assets/css.png";
import jquery from  "../assets/jquery.png"
import javascript from "../assets/javascript.png";
import reactImage from "../assets/react.png";
import sass from "../assets/sass.png";
import bootstrap from "../assets/bootstrap.png";
import tailwind from "../assets/tailwind.png";
import redux from "../assets/redux.png";


const ExperienceEtCompetences = () => {
  const techsFront = [
    {
      id: 1,
      src: html,
      title: "HTML",
      style: "shadow-orange-500",
    },
    {
      id: 2,
      src: css,
      title: "CSS",
      style: "shadow-blue-500",
    },
    {
      id: 3,
      src: javascript,
      title: "JavaScript",
      style: "shadow-yellow-500",
    },
    {
      id: 4,
      src: jquery,
      title: "Jquery",
      style: "shadow-blue-900",
    },
    {
      id: 7,
      src: reactImage,
      title: "React Native",
      style: "shadow-blue-400",
    },
    {
      id: 8,
      src: reactImage,
      title: "React",
      style: "shadow-blue-400",
    },
    {
      id: 5,
      src: tailwind,
      title: "Tailwind",
      style: "shadow-sky-400",
    },
    {
      id: 6,
      src: bootstrap,
      title: "bootstrap",
      style: "shadow-violet-700",
    },
    
    {
      id: 9,
      src: sass,
      title: "Sass",
      style: "shadow-pink-400",
    },
    {
      id: 10,
      src: redux,
      title: "React redux",
      style: "shadow-violet-700",
    },
   
   




  ];


  return (
    <div
      name="skills"
      className="bg-gradient-to-b from-gray-800 to-black w-full h-screen"
    >
      <div className="max-w-screen-lg mx-auto p-4 flex flex-col justify-center w-full h-full  text-white">
        <div className="mt-96 ">
          <p className="text-4xl font-bold border-b-4 border-gray-500 p-2 inline ">
            Competences Front-End : 
          </p>
          
        </div>

        <div className="w-full grid grid-cols-2 sm:grid-cols-3  gap-8 text-center py-8 px-12 sm:px-0  mb-20">
          {techsFront.map(({ id, src, title, style }) => (
            <div
              key={id}
              className={`shadow-md hover:scale-105 duration-500 py-2 rounded-lg m-5 ${style}`}
            >
              <img src={src} alt="" className="w-20 mx-auto" />
              <p className="mt-4">{title}</p>
            </div>
          ))}
          
        </div>
       

      </div>
      
    </div>
  );
};

export default ExperienceEtCompetences;
